import React from 'react';
import { Container } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import Bttons from '../Comoncomponent/Bttons';

const DefaultButtonContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Default Style' parent='Buttons' title='Default Style' />
      <Bttons />
    </Container>
  );
};
export default DefaultButtonContainer;
